import { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import PastEvents from "../components/Dashboard/UserDashboard/PastEvent";
import Connections from "../components/Dashboard/UserDashboard/Connections";
import Profile from "../components/Dashboard/UserDashboard/Profile";
import UpcomingEvents from "../components/Dashboard/UserDashboard/Upcoming Events";
import Messages from "../components/Dashboard/UserDashboard/Messages";
import Settings from "../components/Dashboard/UserDashboard/Settings";
import LogoHeader from "../components/Dashboard/UserDashboard/LogoHeader";
import Sidebar from "../components/Dashboard/UserDashboard/Sidebar";
import MainHeader from "../components/Dashboard/UserDashboard/MainHeader";
import Banner from "../components/Dashboard/UserDashboard/Banner";
import Meeting from "../components/Dashboard/UserDashboard/Meeting";

// This component renders the User Dashboard page.
// It contains the following sections: Profile, Past Events, Connections, Upcoming Events, Messages, Settings.
const UserDashboard = () => {
  const location = useLocation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (location.pathname === "/userdashboard") {
      setShowBanner(true);
    } else {
      setShowBanner(false);
    }
  }, [location.pathname]);

  return (
    <div className="UserDashboard">
      <div className="left-side-box">
        <LogoHeader />
        <Sidebar />
      </div>
      <div className="right-side-box">
        <MainHeader />
        {showBanner && <Banner />}
        <div className="content-box">
          <Routes>
            <Route path="profile" element={<Profile />} />
            <Route path="past-events" element={<PastEvents />} />
            <Route path="connections" element={<Connections />} />
            <Route path="upcoming-events" element={<UpcomingEvents />} />
            <Route path="messages" element={<Messages />} />
            <Route path="meetings" element={<Meeting />} />
            <Route path="settings" element={<Settings />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
